var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



//////////////////
// WEBPACK FOOTER
// /home/g0/live-stream/web-client/node_modules/core-js/modules/_user-agent.js
// module id = 871j
// module chunks = 5 6 7 8